import {Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {TranslocoService} from "@ngneat/transloco";
import {ICRUDRecord, IResource, ISelectedSchedScene, ISelectedSchedSceneItem} from "../../../interfaces";
import {actionAddScheduleSceneItem, actionCRUDRecord, actionRemoveScheduleSceneItem} from "../../../store/actions/user.actions";
import {LocalStoreService, StoreSelectorsService} from "../../../services";
import {Compbaser} from "../../../components/compbaser";
import {compareIds, preprocessSceneRecord} from 'app/common';
import {faDatabase} from "@fortawesome/free-solid-svg-icons";
import {Memoizee} from "../../../decorators/memoizee-decorator";
import {ITableIconPipe} from "../../../pipes/table-list-icon-pipe";
import {IconDefinition} from "@fortawesome/fontawesome-common-types";
import {ITableListColumn, ITableListEvent} from "../../../components/table-list-input/table-list-input.component";
import {IButtonBar} from "../../../components/add-remove-bar/button-bar.component";
import {FormBuilder, FormGroup} from "@angular/forms";
import {delay, map, take} from "rxjs/operators";
import {SelectionModel} from "@angular/cdk/collections";
import {combineLatest} from "rxjs";
import {MatSort} from "@angular/material/sort";
import {MatPaginator} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";
import {IGroupCollection} from "../../../interfaces/enterprise-interface";
import * as _ from 'lodash';


@Component({
    selector: 'app-scenes-scheduler',
    templateUrl: './scene-scheduler.component.html',
    styleUrls: ['./scene-scheduler.component.scss']
})
export class SceneSchedulerComponent extends Compbaser implements OnInit {

    buttons: IButtonBar[] = [];
    tableColumns: Array<ITableListColumn> = [];
    group: FormGroup;
    resources: IResource[];
    displayedColumns: string[] = ['select', 'schedule_name'];

    groupCollection: IGroupCollection;
    isFullFeatures: boolean;
    pageSize = 10;
    dialogRefVal;

    dataSource: MatTableDataSource<ISelectedSchedScene>;
    selectedSchedules: Array<ISelectedSchedScene> = [];
    selectedSceneModel: SelectionModel<number>;
    importCheckboxesModal: SelectionModel<number>;

    @ViewChild("importSchedModal", {read: TemplateRef}) importSchedModal: TemplateRef<any>;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @Input() pageSizeOptions: Array<any> = [10, 20, 30];

    constructor(private storeSelector: StoreSelectorsService,
                private translocoService: TranslocoService,
                private fb: FormBuilder,
                private localStoreService: LocalStoreService,
                public override dialog: MatDialog) {
        super();
        const initialSelection = [];
        const allowMultiSelect = true;
        this.importCheckboxesModal = new SelectionModel<number>(allowMultiSelect, initialSelection);
        this.pageSize = parseInt(this.localStoreService.getStorageValConfig('pageSize')) || 10;
        this.buttons = [
            {
                callBack: v => (v),
                icon: 'add',
                name: 'add',
                disableByList: false,
                disabled: false,
                tooltip: this.translocoService.translate('general.add', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'remove',
                name: 'remove',
                disableByList: true,
                confirmRemove: this.translocoService.translate('toast.deleteConfirm', {}, this.translocoService.getActiveLang()),
                disabled: false,
                tooltip: this.translocoService.translate('general.remove', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'arrow_left',
                name: 'previous',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.next', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'arrow_right',
                name: 'next',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.previous', {}, this.translocoService.getActiveLang())
            }
        ];

        this.tableColumns = [
            {
                inputType: 'text',
                label: this.translocoService.translate('general.playbackScheduler', {}, this.translocoService.getActiveLang()),
                name: 'schedule',
                maxStringSize: '165'
            }
        ];
    }

    @Input()
    set setSceneSelectionModel(i_selectionModel: SelectionModel<number>) {
        this.selectedSceneModel = i_selectionModel;
    }

    ngOnInit() {
        this.group = this.fb.group({tableCatalog: []});
        this.composeSelectedScene();
    }

    composeSelectedScene() {
        this.cod(
            combineLatest([this.storeSelector.getSchedules(), this.storeSelector.getScene(this.selectedSceneModel.selected[0])]).pipe(
                map(([schedules, scenePlayer]) => {
                    const results: Array<ISelectedSchedScene> = [];
                    if (scenePlayer.Player?.Metadata?.[0]?.Schedules?.[0].Schedule?.length > 0) {
                        scenePlayer.Player.Metadata[0].Schedules[0].Schedule.forEach((d) => {
                            schedules.forEach((g) => {
                                if (compareIds(g.schedule_id, d.$.id)) {
                                    results.push({schedule_name: g.schedule_name, schedule_id: g.schedule_id});
                                }
                            });
                        });
                    }
                    return results;
                })
            ).subscribe((v) => {
                this.selectedSchedules = v;
                this.renderSchedules(v);
            })
        );
    }

    private renderSchedules(v) {
        this.group.get('tableCatalog').setValue(v);
        // this.cd.markForCheck();
    }

    private updateScene(sceneId) {
        this.cod(
            this.storeSelector.getScene(sceneId)
                .pipe(
                    delay(5),
                    take(1))
                .subscribe((scene) => {
                    const saveRecord: ICRUDRecord = preprocessSceneRecord(scene, sceneId, this.localStoreService.getStorageConfig().studioId, 'update');
                    this.storeSelector.dispatch(actionCRUDRecord({saveRecord}));
                })
        );
    }

    @Memoizee({})
    onCallBackEventTableFaIcon(): (v: ITableIconPipe) => IconDefinition {
        return (v) => {
            if (v.index === 0) return faDatabase;
            return null;
        };
    }

    onCallBackValueTableEvents() {
        return (item, direction) => {
            switch (direction) {
                case 'IN': {
                    item.$ = {schedule: item.schedule_name, id: item.schedule_id};
                    return item;
                }
                case 'OUT': {
                    item.$ = {schedule: item.schedule_name, id: item.schedule_id};
                    delete item.$;
                    return item;
                }
            }
        };
    }

    openAssociateDialog() {
        this.dialogRefVal = this.dialog.open(this.importSchedModal, {
            height: '90%',
            width: '50%',
            data: ''
        });
        this.createDataSource();
        // this.cod(
        //     this.dialogRefVal.afterClosed()
        //         .subscribe((dialogGetAssets: IDialogGetAsset[]) => {
        //             if (!dialogGetAssets || !Array.isArray(dialogGetAssets)) return;
        //         })
        // );
    }

    import() {
        this.dialogRefVal.close();
        if (this.importCheckboxesModal.selected.length === 0) return;

        let selectedSchedScene: Array<ISelectedSchedSceneItem> = [];
        this.importCheckboxesModal.selected.forEach((i: any) => {
            selectedSchedScene.push({$: {id: i}});
        });
        this.selectedSchedules.forEach((i: any) => {
            selectedSchedScene.push({$: {id: i.schedule_id}});
        });
        selectedSchedScene = _.uniqBy(selectedSchedScene, (e) => {
            return e.$.id;
        });
        this.storeSelector.dispatch(actionAddScheduleSceneItem({
            sceneId: this.selectedSceneModel.selected[0],
            schedulerIds: selectedSchedScene
        }));
        this.updateScene(this.selectedSceneModel.selected[0]);
    }

    createDataSource() {
        this.cod(
            this.storeSelector.getSchedules().pipe(
                map((a) => {
                    return a.filter((b) => {
                        const f = this.selectedSchedules.find((c) => compareIds(b.schedule_id, c.schedule_id));
                        return f ? false : true;
                    });
                })
            ).subscribe((v: any) => {
                this.dataSource = new MatTableDataSource(v);
            })
        );
    }

    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
        const numSelected = this.importCheckboxesModal.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    /** Selects all rows if they are not all selected; otherwise clear checkedSelection. */
    masterToggle() {
        if (this.isAllSelected()) {
            this.importCheckboxesModal.clear();
        } else {
            this.dataSource.data.forEach(row => this.importCheckboxesModal.select(row.schedule_id as any));
        }
    }

    resourceChecked(resourceId) {
        // this.itemSelected.emit(resourceId);
        // this.selectedItems.emit(this.checkedSelection);
    }

    onTableListUpdate(e: ITableListEvent) {
        switch (e.currentAction) {
            case 'added': {
                this.openAssociateDialog();
                break;
            }
            case 'removed': {
                this.storeSelector.dispatch(actionRemoveScheduleSceneItem({
                    sceneId: this.selectedSceneModel.selected[0],
                    schedulerId: {
                        $: {
                            id: e.selected[0].schedule_id
                        }
                    }
                }));
                this.updateScene(this.selectedSceneModel.selected[0]);
                break;
            }
        }
    }
}

